import React from "react"
import PropTypes from "prop-types"
import Image from "../Image/Image"
const Link = props => {
  const {
    label,
    url,
    target,
    title,
    className = "",
    children,
    onFocus,
    onBlur,
    id,
    scrollToElementId,
    gaEventClass,
    gaEventLabel = "",
    image,
  } = props
  const regex = new RegExp(
    "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
  )
  const isExternallink = regex.test(url)
  let pageUrl
  if (url) {
    pageUrl = !url?.trim()?.endsWith("/") && !(url?.trim()?.endsWith(".pdf") || isExternallink) ? `${url}` : url
  }
  let href = pageUrl
  if (pageUrl && scrollToElementId) {
    href = `${pageUrl}#${scrollToElementId}`
  } else if (!pageUrl && scrollToElementId) {
    href = `#${scrollToElementId}`
  }


  const targetWindow = target || (isExternallink ? "_blank" : "_self")

  // if image is there, pass down event to image element
  const eventClassFinal = gaEventClass
    ? gaEventClass
    : isExternallink
      ? "event_external_link"
      : "event_internal_link"

  const classNameFinal = className
    ? [className, eventClassFinal].join(" ")
    : eventClassFinal
  const content = children || (
    <>
      {image ? (
        <Image
          contentfulImage={image}
          eventClass={gaEventClass}
          eventLabel={gaEventLabel}
        />
      ) : (
        label || null
      )}
    </>
  )

  if (!url && !scrollToElementId) {
    return <div className={classNameFinal}>{content}</div>
  }

  // if image is there, pass down event to image element
  const dataAction = !image ? gaEventLabel || href : ""
  return (
      <a
        href={pageUrl+(scrollToElementId ? `#_${scrollToElementId}_` : "")}
        target={targetWindow}
        className={classNameFinal}
        onFocus={onFocus}
        onBlur={onBlur}
        data-action-detail={gaEventLabel}
        id={id}
      >
        {content || children}
      </a>
  )
}

Link.propTypes = {
  label: PropTypes.any,
  url: PropTypes.string,
  target: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  scrollToElementId: PropTypes.string,
  image: PropTypes.object,
  id: PropTypes.string,
  gaEventClass: PropTypes.string,
  gaEventLabel: PropTypes.string,
  onClick: PropTypes.func,
}

export default Link
